import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../services/auth';

const ForgotPassword = () => {

    const [identifier, setIdentifier] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!identifier) {
      setError('Please enter your employee code or email.');
      return;
    }

    try {
        const response = await forgotPassword(identifier);
        setMessage(response.data.detail);
        setError('');
    } catch (err) {
        setMessage('');
        if (err.response?.data?.detail) {
            setError(err.response.data.detail);
        } else {
            setError('Something went wrong. Please try again.');
        }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-sm bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">Forgot Password</h2>

        {message && (
          <div className="text-green-600 text-sm text-center mb-3">{message}</div>
        )}

        {error && (
          <div className="text-red-600 text-sm text-center mb-3">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-600">Employee Code or Email</label>
            <input
              type="text"
              className="w-full mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
            />
          </div>

          <div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
            >
              Reset Password
            </button>
          </div>

          <div className="text-center mt-2">
            <button
              type="button"
              className="text-sm text-blue-600 hover:underline"
              onClick={() => navigate('/login')}
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
